const appVersion = process.env.REACT_APP_APP_VERSION || 'local-dev';
export default appVersion;
